import { React, useCallback, useState } from "react";
import moment from "moment";
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';

import Modal from "../../../../components/modal";


function PatientSearchForm(props) {
    const {
        handleFetchSearchResults,
        fetchError,
    } = props;

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [dob, setDOB] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [isCalendarOpen, setIsCalendarOpen] = useState(false)


    const searchPatients = useCallback(() => {
        handleFetchSearchResults({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            dob: dob && dob !== "" ? moment(dob).format("YYYY-MM-DD") : "",
            phone: phone.trim(),
            email: email.trim().toLowerCase(),
            staff_id: localStorage.getItem("staffId"),
        })
    }, [dob, email, firstName, handleFetchSearchResults, lastName, phone]);

    return (
        <form
            className="w-full flex flex-col gap-5"
            onSubmit={(event) => {
                event.preventDefault();
                searchPatients();
            }}
        >
            {fetchError && <p className="mt-4 text-center text-red-600 text-lg font-bold">{fetchError}</p>}
            <h1 className="text-center text-xl font-semibold mb-5">
                Search Clients
            </h1>
            <input
                type="text"
                className="custom-input px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975]"
                value={firstName}
                placeholder="First name"
                onChange={(event) => {
                    setFirstName(event.target.value);
                }}
            />
            <input
                type="text"
                className="custom-input px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975]"
                value={lastName}
                placeholder="Last name"
                onChange={(event) => {
                    setLastName(event.target.value);
                }}
            />
            <div className="flex flex-col w-full">
                <input
                    type="text"
                    placeholder="Date of birth"
                    className="custom-input px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975] !w-full"
                    readOnly
                    required
                    value={dob}
                    onClick={() => setIsCalendarOpen(true)}
                />
            </div>
            <input
                type="tel"
                className="custom-input px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975]"
                value={phone}
                placeholder="Phone"
                onChange={(event) => {
                    setPhone(event.target.value);
                }}
            />
            <input
                type="email"
                className="custom-input px-6 py-3 bg-text-1 rounded-lg text-xl font-normal focus:outline-none text-[#3E6975]"
                value={email}
                onChange={(event) => {
                    setEmail(event.target.value);
                }}
                placeholder="Email"
            />
            <input
                className="mt-5 px-8 py-3 bg-[#f4831f] font-semibold rounded-[5px] text-white cursor-pointer capitalize focus:outline-none"
                type="submit"
                value={'Search'}
            />
            <Modal
                open={isCalendarOpen}
                onClose={() => setIsCalendarOpen(false)}
                className={'!rounded-2xl p-2 !bg-background-1'}
                children={
                    <div className="flex flex-col gap-2">
                        <h6 className="p-2 text-text-1 text-base">Selected Date: {dob || "NA"}</h6>
                        <Calendar
                            className={'p-2 rounded text-base !bg-background-1 !text-text-1 !border-none !outline-none'}
                            onChange={(selectedDate) => {
                                const formattedDate = selectedDate.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                })
                                setDOB(formattedDate);
                            }}
                            defaultActiveStartDate={new Date('1980-01-01')}
                            calendarType="gregory"
                            tileClassName={'!p-3.5 !text-white !bg-transparent'}
                            defaultValue={dob ? new Date(dob) : undefined}

                        />
                        <div className="flex items-center justify-end p-2">
                            <p
                                className={
                                    Boolean(dob) ? "cursor-pointer text-[#f4831f]" : "cursor-not-allowed text-[#f4831f]/30"
                                }
                                onClick={() => setIsCalendarOpen(false)}
                            >
                                Ok
                            </p>
                        </div>
                    </div>
                }
            />
        </form>
    )
}

export default PatientSearchForm